var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cielo-radio",class:{selected: _vm.value},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }